<script lang="ts">
import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
import { PaymentMeansTypes } from '@/generated/classes/PaymentMeans';
import HubServices from '@/generated/hub/HubServices';
import SectionSalaireMeans from '@/generated/sections/SectionSalaireMeans.vue';
import { storePaymentMeans, storeSession } from '@/generated/stores';
import Owner from '@/extend/classes/Owner';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import DialogHubManager from "@/framework/dialog/helpers/DialogHubManager";
import { defineComponent } from "vue";
import Salarie from "@/extend/classes/Salarie.ts";

export default defineComponent({
  components: {},
  extends: SectionSalaireMeans,
  data() {
    const localFiler: ColumnFilter[] | null = [];
    return {
      localFiler
    }
  },
  created(): void {
    HubServices.connection.invoke('EnterPaymentMeans', storeSession.httpToken);
    HubServices.connection.on('PaymentMeansCreated', this.togglePaymentMeans);
    HubServices.connection.on('PaymentMeansUpdated', this.togglePaymentMeans);
    HubServices.connection.on('PaymentMeansDeleted', this.togglePaymentMeans);
    DialogHubManager.waitAnswer('createPaymentMeans', this.togglePaymentMeans);
  },
  beforeUnmount(): void {
    HubServices.connection.off('PaymentMeansCreated', this.togglePaymentMeans);
    HubServices.connection.off('PaymentMeansUpdated', this.togglePaymentMeans);
    HubServices.connection.off('PaymentMeansDeleted', this.togglePaymentMeans);
  },
  computed: {
    owner(): Owner {
      const owner = new Owner();
      owner.objType = ObjTypes.CLIENT;
      owner.objId = this.editEtablissement.clientId;
      return owner;
    },
    salaireMeansIdFilter(): ColumnFilter[] {
      if (this.owner.objId > 0) {
        const res: ColumnFilter[] = [];
        {
          const filter = new ColumnFilter();
          filter.name = "type";
          filter.sortAscending = true;
          const virement = new ListChoix();
          virement.value = PaymentMeansTypes.VIREMENT;
          filter.filters.push(virement);
          const prelevement = new ListChoix();
          prelevement.value = PaymentMeansTypes.RIB;
          filter.filters.push(prelevement);
          const cb = new ListChoix();
          cb.value = PaymentMeansTypes.CARTE_BANCAIRE;
          filter.filters.push(cb);
          res.push(filter);
        }
        {
          const filter = new ColumnFilter();
          filter.name = "ownerType";
          filter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = this.owner.objType
          filter.filters.push(choix);
          res.push(filter);
        }
        {
          const filter = new ColumnFilter();
          filter.name = "ownerId";
          filter.staticFilter = true;
          {
            const choix = new ListChoix();
            choix.value = this.owner.objId;
            filter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = 0;
            filter.filters.push(choix);
          }
          res.push(filter);
        }
        return res;
      } else {
        return null;
      }
    }
  },
  methods: {
    togglePaymentMeans(): void {
      this.toggleSalaireMeansId = !this.toggleSalaireMeansId;
    },
    isDisplayed(value: string): boolean {
      let res = false;
      if (value == 'SALAIRE_MEANS_ID') {
        res = true;
      } else if (value == 'PAYMENT_AUTO_SALAIRE') {
        if (this.editEtablissement.salaireMeansId > 0) {
          const payment = storePaymentMeans.getPaymentMeans(this.editEtablissement.salaireMeansId);
          if (payment.type == PaymentMeansTypes.CARTE_BANCAIRE || payment.type == PaymentMeansTypes.RIB) {
            res = true;
          }
        }
        res = false; // DISABLED (BUG IN PROCESS)
      }
      return res;
    }
  }
})

</script>
